import { IsLoggedInGuard, RequiresPermissionGuard } from '@lexplus-authentication';
import { LexplusPermissionsEnum } from '@lexplus-authentication-api';
import { DetailDrawerType } from '@lexplus-shared-lib';
import { LOCALIZED_USER_ROUTES, USER_ROUTES_IDS } from '../../../localized-user-routes-const';
import { UserDetailDrawerTypeKey } from '../../../global/models/user-detail-drawer-type-key.model';

/**
 * Each of the three Aufgaben permissions opens the overview; they differ in scope and
 * in write access. Spelled out rather than indexed through LEXPLUS_PERMISSIONS_ENUM,
 * whose order the generated client decides.
 */
export const AUFGABEN_PERMISSIONS: LexplusPermissionsEnum[] = [
  LexplusPermissionsEnum.UserAufgabenReadonly,
  LexplusPermissionsEnum.UserAufgabenEigene,
  LexplusPermissionsEnum.UserAufgabenAlle,
];

/**
 * An Aufgabe as the detail drawer shows it, behind the same permissions as the Aufgaben overview.
 *
 * @param {string} locale - The base language, which localizes the segment
 * @returns {DetailDrawerType} The Aufgabe's definition for the drawer
 */
export function buildAufgabeDetailDrawerType(locale: string): DetailDrawerType<UserDetailDrawerTypeKey> {
  return {
    segment: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_TASKS][locale],
    label: $localize`:@@aufgaben.drawer.typ:Aufgabe`,
    drawerLabel: $localize`:@@aufgaben.drawer.label:Aufgaben-Details`,
    loadComponent: () => import('../pages/aufgabe-detail-page/aufgabe-detail-page.component').then((m) => m.AufgabeDetailPageComponent),
    canActivate: [IsLoggedInGuard, RequiresPermissionGuard],
    data: { requiredAnyPermission: AUFGABEN_PERMISSIONS },
    opens: ['anforderung', 'erlass', 'individuelleAnforderung'],
  };
}
